import { usePut } from '../../HttpClient';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useUpdateChargeOffReason() {
  const put = usePut(true, "tms");
  const updateChargeOffReason = (id: string, request: { reason: string }) =>
    put<{ id: string }>(`${referenceDataBaseUrl}/charge-off-reasons/${id}`, request);

  return useMutationWithErrorHandling({
    mutationFn: async ({ id, request }: { id: string; request: { reason: string } }) =>
      await updateChargeOffReason(id, request),
  });
}
